import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { createGlobalStyle } from 'styled-components';
import resetCss from '../../../../client/reset.css?raw';
import avenir from './avenir';
// TODO: import font
const GlobalStyles = createGlobalStyle `
  ${avenir};
  ${resetCss};

  :root {
    --accentColor: initial;
    --accentContrastColor: initial;
    --bgColor: initial;
    --fgColor: ${brand.white};
    --gutterWidth: initial;
    --headerHeight: ${fluid(48, 91)};
    --sectionSpacing: initial;
    --sitePadding: initial;
    --siteWidth: initial;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    // TODO: font and colour styles
    padding-top: var(--headerHeight) !important;
    overscroll-behavior-x: none;
    color: ${brand.white};
    background-color: ${brand.black};

    &.sb-show-main {
      background-color: ${brand.black} !important;
    }

    &.modal-open {
      overflow: hidden;
    }
  }

  img {
    max-width: 100%;
  }

  * {
    box-sizing: border-box;
  }

  span {
    display: inline-block;
  }

  sub {
    position: relative;
    top: 0.5em;
    font-size: 80%;
  }

  sup {
    position: relative;
    top: -0.5em;
    font-size: 80%;
  }

  .hidden {
    display: none;
    visibility: none;
  }

  #main {
    position: relative;
    z-index: 1;
    padding-top: var(--headerHeight);
  }

  /* OneTrust Cookie Banner styles */
  #onetrust-consent-sdk {
    --siteWidth: 1400px;
    --sitePadding: 16px;

    font-family: Avenir, sans-serif;
  }

  #onetrust-consent-sdk #onetrust-banner-sdk {
    border-top: 1px solid #E2DBD4;
    background-color: #181818 !important;
    padding: 30px 0;
  }

  #onetrust-consent-sdk #onetrust-policy-text {
    color: #fff !important;
  }

  #onetrust-consent-sdk .ot-sdk-container {
    width: 100%;
    max-width: calc(var(--siteWidth) + var(--sitePadding) + var(--sitePadding));
    margin: 0 auto;
    padding: 0 var(--sitePadding);
  }

  #onetrust-consent-sdk .ot-sdk-container .ot-sdk-row {
    display: flex;
    flex-direction: column;
  }

  #onetrust-banner-sdk:not(.ot-iab-2).vertical-align-content #onetrust-button-group-parent {
    position: relative !important;
    left: auto !important;
    top: auto !important;
    margin: 0;
    transform: translateY(0) !important;
    width: auto;
  }

  #onetrust-banner-sdk #onetrust-button-group-parent #onetrust-accept-btn-handler, 
  #onetrust-banner-sdk #onetrust-button-group-parent #onetrust-reject-all-handler, 
  #onetrust-banner-sdk #onetrust-button-group-parent #onetrust-pc-btn-handler {
    text-transform: uppercase;
    font-family: Avenir, sans-serif;
    letter-spacing: 0.2em;
    padding: 11px 25px;
    border-radius: 1e+06px;
    font-weight: 500;
    background-color: transparent;
    color: #B4A593;
    border: 1px solid #B4A593;
    transition-duration: 0.35s;
    transition-property: color, background-color, border-color;
    transition-timing-function: cubic-bezier(0.33, 1, 0.68, 1);
    margin: 0;
  }

  #onetrust-banner-sdk #onetrust-button-group-parent #onetrust-accept-btn-handler:hover, 
  #onetrust-banner-sdk #onetrust-button-group-parent #onetrust-reject-all-handler:hover, 
  #onetrust-banner-sdk #onetrust-button-group-parent #onetrust-pc-btn-handler:hover {
    background-color: #B4A593;
    color: #000;
    border: 1px solid #B4A593;
    opacity: 1 !important;
  }

  #onetrust-banner-sdk #onetrust-button-group {
    float: none;
    display: flex !important;
    flex-wrap: wrap;
    flex-direction: column;
    gap: 20px;
    width: auto !important;    
  }

  #onetrust-banner-sdk #onetrust-group-container {
    float: none;
    width: auto !important;
  }

  /* Settings modal */
  #onetrust-consent-sdk #onetrust-pc-sdk {
    background-color: ${brand.black};
    border: 1px solid ${brand.white};
    box-shadow: none;
  }

  #onetrust-pc-sdk #close-pc-btn-handler.ot-close-icon {
    filter: brightness(3);
  }

  #onetrust-consent-sdk #onetrust-pc-sdk #ot-pc-title,
  #onetrust-consent-sdk #onetrust-pc-sdk #ot-pc-desc,
  #onetrust-consent-sdk #onetrust-pc-sdk .privacy-notice-link,
  #onetrust-consent-sdk #onetrust-pc-sdk h3 {
    color: ${brand.white};
  }

  #onetrust-pc-sdk .ot-btn-container button,
  #onetrust-consent-sdk #onetrust-pc-sdk button:not(#clear-filters-handler):not(.ot-close-icon):not(#filter-btn-handler):not(.ot-remove-objection-handler):not(.ot-obj-leg-btn-handler):not([aria-expanded]):not(.ot-link-btn) {
    border: 1px solid ${brand.primary.beige};
    background-color: ${brand.primary.beige};
    color: ${brand.black};
    border-radius: 1000000px;

    &:hover {
      border-color: ${brand.primary.beige};
      background-color: transparent;
      color: ${brand.primary.beige};
    }

    &:active {
      border-color: ${brand.white};
      background-color: ${brand.white};
      color: ${brand.black};
    }

    &:focus {
      outline: auto;
      outline-color: currentColor;
      outline-offset: 5px;
      outline-width: thin;
    }
  }

  .ot-floating-button__front {
    filter: grayscale(1);
  }

  #ot-sdk-btn-floating .ot-floating-button__back {
    background-color: ${brand.primary.textLight};
  }

  @media (min-width: 550px) {
    #onetrust-banner-sdk #onetrust-button-group {
      padding: 0 50px !important;
    }
  }

  @media (min-width: 768px) {
    #onetrust-banner-sdk #onetrust-button-group {
      flex-direction: row;
      margin-right: auto !important;
      justify-content: center;
      padding: 0 50px !important;
    }

  }

  @media (min-width: 1024px) {
    #onetrust-consent-sdk {
      --sitePadding: 32px;
    }
    
    

    #onetrust-banner-sdk #onetrust-button-group {
      flex: 1 0 auto;
    }
    
    #onetrust-banner-sdk #onetrust-group-container {
      flex: 1 1 40%;
      width: auto !important;
    }

    #onetrust-banner-sdk:not(.ot-iab-2) #onetrust-button-group-parent {
      padding: 0 !important;
    }

  }

  @media (min-width: 1280px) {
    #onetrust-consent-sdk .ot-sdk-container .ot-sdk-row {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  }

  @media (max-width: 1279px) {
    #onetrust-banner-sdk #onetrust-policy {
      margin: 0 32px 30px !important;
    }
  }

  @media (max-width: 549px) {
    #onetrust-banner-sdk #onetrust-policy {
      margin: 0 0 30px !important;
    }
  }
`;
export default GlobalStyles;
